import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./lib/auth";
import { I18nProvider } from "./lib/i18n";
import { Toaster } from "sonner";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Projects from "./pages/Projects";
import ProjectDetail from "./pages/ProjectDetail";
import StageNew from "./pages/StageNew";
import InspectionDetail from "./pages/InspectionDetail";
import Queue from "./pages/Queue";
import AdminUsers from "./pages/AdminUsers";
import AdminNorms from "./pages/AdminNorms";
import AdminAudit from "./pages/AdminAudit";
import AdminTariffs from "./pages/AdminTariffs";
import Contractors from "./pages/Contractors";
import Correction from "./pages/Correction";
import Notifications from "./pages/Notifications";
import Reports from "./pages/Reports";
import Layout from "./components/Layout";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading)
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-pulse mono">Yüklənir...</div>
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  return <Layout>{children}</Layout>;
}

function RoleGate({ allow, children }) {
  const { user } = useAuth();
  if (!user) return null;
  if (!allow(user.role)) return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <I18nProvider>
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-right" richColors />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<Protected><Dashboard /></Protected>} />
            <Route path="/projects" element={<Protected><Projects /></Protected>} />
            <Route path="/projects/:id" element={<Protected><ProjectDetail /></Protected>} />
            <Route path="/projects/:id/stage/new" element={<Protected><StageNew /></Protected>} />
            <Route path="/inspections/:id" element={<Protected><InspectionDetail /></Protected>} />
            <Route path="/queue" element={<Protected><Queue /></Protected>} />
            <Route path="/correction" element={<Protected><Correction /></Protected>} />
            <Route path="/notifications" element={<Protected><Notifications /></Protected>} />
            <Route path="/reports" element={
              <Protected>
                <RoleGate allow={(r) => r === "superadmin" || r.startsWith("aayda_")}>
                  <Reports />
                </RoleGate>
              </Protected>
            } />
            <Route path="/contractors" element={<Protected><Contractors /></Protected>} />
            <Route path="/admin/users" element={
              <Protected>
                <RoleGate allow={(r) => r === "superadmin"}>
                  <AdminUsers />
                </RoleGate>
              </Protected>
            } />
            <Route path="/admin/norms" element={
              <Protected>
                <RoleGate allow={(r) => r === "superadmin"}>
                  <AdminNorms />
                </RoleGate>
              </Protected>
            } />
            <Route path="/admin/audit" element={
              <Protected>
                <RoleGate allow={(r) => r === "superadmin"}>
                  <AdminAudit />
                </RoleGate>
              </Protected>
            } />
            <Route path="/admin/tariffs" element={
              <Protected>
                <RoleGate allow={(r) => r === "superadmin"}>
                  <AdminTariffs />
                </RoleGate>
              </Protected>
            } />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </I18nProvider>
  );
}

export default App;
